import { DEFAULT_RATE } from "./constants";
import { queryElements, readConfig, createState } from "./setup";
import { createRender } from "./render";
import { createActions } from "./actions";
import { bindAudioEvents } from "./audioEvents";
import { bindProgress } from "./progress";
import { bindSpeedMenu } from "./speedMenu";
import { bindShortcuts } from "./shortcuts";
import { readStoredVolume } from "./volumeStorage";

function init(root) {
    const audio = root.querySelector("audio");
    const player = {
        root,
        audio,
        el: queryElements(root),
        cfg: readConfig(root),
        state: createState()
    };
    const { el, cfg, state } = player;

    player.isReady = () => state.duration > 0;
    player.isSeekDisabled = () => state.hasError || !player.isReady();

    player.track = (type, extra) => {
        root.dispatchEvent(
            new CustomEvent("podcast-player:track", {
                bubbles: true,
                detail: Object.assign({ type, name: cfg.name, currentTime: audio.currentTime, duration: state.duration }, extra)
            })
        );
    };

    player.render = createRender(player);
    player.actions = createActions(player);
    const { syncFromElement, startDurationPolling } = bindAudioEvents(player);
    bindProgress(player);

    const { actions } = player;
    el.play.addEventListener("click", actions.togglePlay);
    el.skips.forEach(b => b.addEventListener("click", () => actions.skip(Number(b.dataset.skip))));
    el.mute.addEventListener("click", actions.toggleMute);
    el.volume.addEventListener("input", () => actions.setVolume(Number(el.volume.value) / 100));
    el.retry.addEventListener("click", actions.retry);

    bindSpeedMenu(player);
    bindShortcuts(player);

    syncFromElement();
    state.isPlaying = !audio.paused;
    state.isMuted = audio.muted;
    audio.volume = readStoredVolume(); // iOS ignores this; reading back keeps the UI honest
    state.volume = audio.volume;
    state.playbackRate = audio.playbackRate || DEFAULT_RATE;
    startDurationPolling();
    player.render();
}

export default function podcastPlayer() {
    document.querySelectorAll("[data-podcast-player]").forEach(root => {
        if (root.dataset.podcastPlayerReady) return;
        root.dataset.podcastPlayerReady = "true";
        init(root);
    });
}
